import { render, staticRenderFns } from "./bons-attente.html?vue&type=template&id=d8521d70&scoped=true&external"
import script from "./bons-attente.js?vue&type=script&lang=js&external"
export * from "./bons-attente.js?vue&type=script&lang=js&external"
import style0 from "./bons-attente.scss?vue&type=style&index=0&id=d8521d70&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8521d70",
  null
  
)

export default component.exports